<template>
  <div class="page-container">
    <div class="page-header">
      <div class="d-flex align-items-center w-100">
        <b-button variant="link" class="mr-3" @click="onBack()">
          <v-icon name="buttons/chevrons_left" :size="13"/>
        </b-button>
        <h4 v-if="isBusy" id="location-ellipsis-loading" class="mr-auto">Загрузка объекта</h4>
        <h4 v-else class="mr-auto">{{title}}</h4>
        <span v-if="readOnlyButtonVisible" :class="['custom-tag cursor-pointer mr-2', newItem.read_only ? 'tag-danger' : 'tag-success']" @click.stop="readOnlyTapped()">
          <v-icon :name="newItem.read_only ? 'buttons/circle_cross' : 'buttons/circle_check'" class="mr-2" :size="12"/>
          {{ this.newItem.read_only ? 'Редактирование запрещено' : 'Редактирование разрешено' }}
        </span>
        <b-button class="custom-btn-primary" :disabled="isDisabled || loading" @click="handleSubmit()">
          <b-spinner v-if="loading" small/>
          <v-icon name="buttons/check" :size="13"/>
          Сохранить
        </b-button>
      </div>
    </div>

    <div class="page-body" style="overflow-y: auto;">
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-tabs card class="custom-tabs">
            <b-tab disabled>
              <template #title>
                <v-icon name="navbar/locations" :size="13" class="mr-2"/>
                <span>Основная</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="buttons/page_list" :size="13" class="mr-2"/>
                <span>Детали</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="buttons/user_group_add" :size="13" class="mr-2"/>
                <span>Вакансии</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="navbar/recruit_tasks" :size="13" class="mr-2"/>
                <span>Подбор</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="buttons/card_container" :size="13" class="mr-2"/>
                <span>Услуги исполнителей</span>
              </template>
            </b-tab>
            <b-tab title="Работы" disabled>
              <template #title>
                <v-icon name="buttons/work" :size="13" class="mr-2"/>
                <span>Работы</span>
              </template>
            </b-tab>
            <b-tab v-if="canLocationReadFinance()" disabled>
              <template #title>
                <v-icon name="buttons/payment" :size="13" class="mr-2"/>
                <span>Расходы</span>
              </template>
            </b-tab>
            <b-tab v-if="canLocationReadFinance()" disabled>
              <template #title>
                <v-icon name="navbar/staffs" :size="13" class="mr-2"/>
                <span>Сотрудники</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="buttons/phone" :size="13" class="mr-2"/>
                <span>Контакты</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="navbar/reports" :size="13" class="mr-2"/>
                <span>Документы</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="buttons/file" :size="13" class="mr-2"/>
                <span>Медиафайлы</span>
              </template>
            </b-tab>
          </b-tabs>
          <b-card class="custom-card mb-2">
            <!-- Название -->
            <b-row class="mb-2 mt-2">
              <b-col>
                <b-skeleton width="5%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
            </b-row>
            <!-- Заказчик, Город -->
            <b-row class="mb-2">
              <b-col cols="6">
                <b-skeleton width="12%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
              <b-col cols="3" class="d-flex align-items-center mt-2">
                <b-skeleton type="input" width="60%" height="50%"/>
              </b-col>
              <b-col cols="3">
                <b-skeleton width="26%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
            </b-row>
            <!-- Организация, Источник -->
            <b-row>
              <b-col cols="6">
                <b-skeleton width="7%" height="17%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="30%" class="mb-2"/>
                <b-skeleton width="20%" height="14%"/>
              </b-col>
              <b-col>
                <b-skeleton width="25%" height="17%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="30%" class="mb-2"/>
              </b-col>
              <b-col>
                <b-skeleton width="63%" height="17%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="30%" class="mb-2"/>
              </b-col>
            </b-row>
            <!-- Тип оплаты, статус, кагетория -->
            <b-row class="mb-1">
              <b-col cols="6">
                <b-skeleton width="14%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="29%" height="32%"/>
              </b-col>
              <b-col cols="3">
                <b-skeleton width="17%" height="21%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="44%"/>
              </b-col>
              <b-col cols="3">
                <b-skeleton width="27%" height="21%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="44%"/>
              </b-col>
            </b-row>
            <!-- Расходы, Комиссия, Налог, Комиссия, НДС -->
            <b-row class="mb-2">
              <b-col>
                <b-skeleton width="13%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="32%" height="45%"/>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <b-skeleton width="12%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="32%" height="45%"/>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <b-skeleton width="9%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="32%" height="45%"/>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <b-skeleton width="11%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="32%" height="45%"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-skeleton width="7%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="32%" height="45%"/>
              </b-col>
            </b-row>
          </b-card>
        </template>

        <template #default>
          <b-tabs card class="custom-tabs">
            <b-tab active>
              <template #title>
                <v-icon name="navbar/locations" :size="13" class="mr-2"/>
                <span>Основная</span>
              </template>

              <b-card class="custom-card mb-2">
                <h6 class="text-muted text-small">ОСНОВНАЯ ИНФОРМАЦИЯ</h6>
                <b-row>
                  <b-col cols="6">
                    <b-form-group class="mb-0" id="group-name" :label="$t('message.locations.modal.nameInput')">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        placeholder="Введите название"
                        :state="getFieldState('name')"
                        v-model="newItem.name"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group class="mb-0" id="group-town" label="Город">
                      <town-select
                        :value="newItem.town_id"
                        @onSelect="onSelectTown"
                        :is-disabled="isDisabled"
                        :state="getFieldState('town_id')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group class="mb-0" id="group-status" label="Статус объекта">
                      <location-status-select
                        :value="newItem.status_id"
                        @onSelect="onSelectLocationStatus"
                        :is-disabled="isDisabled"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-form-group class="mb-0" id="group-organization" label="Организация" description="Будет отображаться при выставлении счёта">
                      <organization-select
                        ref="organization_select"
                        :is-disabled="isDisabled"
                        :value="newItem.organization_id"
                        :state="getFieldState('organization_id')"
                        @onSelect="onSelectOrg"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group class="mb-0" id="group-customer" :label="$t('message.locations.modal.customerInput')">
                      <customer-select
                        ref="customer_select"
                        :is-disabled="isDisabled"
                        :state="getFieldState('customer_id')"
                        :value="newItem.customer_id"
                        :selected-name="newItem.customer_name"
                        @onSelect="onSelectCustomer"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-button variant="link" style="color: #1A9167 !important; text-decoration: none !important;" v-b-toggle.collapse-customer-details>
                  <v-icon :name="isCustomerOpen ? 'buttons/collapse_chevrons_right' : 'buttons/collapse_chevrons_down'" class="mr-1" :size="12"/>
                  {{ isCustomerOpen ? 'Скрыть реквизиты' : 'Показать реквизиты' }}
                </b-button>

                <b-collapse id="collapse-customer-details" v-model="isCustomerOpen">
                  <b-card class="mb-2 custom-card">
                    <h6 class="text-muted text-small">БАНКОВСКИЕ РЕКВИЗИТЫ</h6>
                    <b-row cols="2" class="align-items-end">
                      <b-col>
                        <b-form-group class="mb-0" id="group-bik" :label="$t('message.customers.modal.bik')">
                          <b-form-input
                            size="sm"
                            autocomplete="off"
                            disabled
                            v-model="customer.bik"
                          />
                        </b-form-group>
                        <b-form-group class="mb-0" id="group-cor-account" :label="$t('message.customers.modal.cor_account')">
                          <b-form-input
                            size="sm"
                            autocomplete="off"
                            disabled
                            v-model="customer.cor_account"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group class="mb-0" id="group-bank" :label="$t('message.customers.modal.bank')">
                          <b-form-input
                            size="sm"
                            autocomplete="off"
                            disabled
                            v-model="customer.bank"
                          />
                        </b-form-group>
                        <b-form-group class="mb-0" id="group-checking-account" :label="$t('message.customers.modal.checking_account')">
                          <b-form-input
                            size="sm"
                            autocomplete="off"
                            disabled
                            v-model="customer.checking_account"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-collapse>
              </b-card>

              <b-card class="custom-card mb-2">
                <h6 class="text-muted text-small">МАРКЕТИНГ</h6>
                <b-row>
                  <b-col>
                    <b-form-group id="group-marketing-source" label='Источник'>
                      <marketing-source-select
                        :value="newItem.marketing_source_id"
                        @onSelect="onSelectMarketingSource"
                        :is-disabled="isDisabled"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="group-marketing-source-comment" label="Источник комментарий">
                      <b-form-input
                        type="text"
                        size="sm"
                        :disabled="isDisabled"
                        v-model="newItem.marketing_source_comment"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
              <b-card class="custom-card">
                <h6 class="text-muted text-small">ФИНАНСОВЫЕ ПАРАМЕТРЫ</h6>
                <b-row>
                  <b-col cols="6">
                    <b-form-group id="group-price" label="Тип оплаты">
                      <b-form-radio-group
                        size="sm"
                        v-model="newItem.payment_type"
                        :disabled="isDisabled"
                        :options="paymentOptions">
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group id="group-category" label="Категория">
                      <b-form-input
                        size="sm"
                        placeholder="Введите категорию для БалансПРО"
                        :disabled="isDisabled"
                        v-model="newItem.category_name"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="canLocationReadFinance()">
                  <b-col lg="3">
                    <b-form-group id="group-management-cost" label="Управленческие расходы">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.management_cost"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col lg="3">
                    <b-form-group id="group-smz-cost" label="Комиссия сервиса СМЗ">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.smz_cost"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col lg="3">
                    <b-form-group id="group-profit-tax" label="Налог на прибыль">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.profit_tax"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col lg="3">
                    <b-form-group id="group-transfer-commission" label="Комиссия за трансфер">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.transfer_commission"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col lg="3" v-if="canLocationReadFinance() && (newItem.payment_type === 1 || newItem.payment_type === 2)">
                    <b-form-group id="group-nds" label="НДС">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.nds"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="canLocationReadFinance() && newItem.payment_type === 2">
                  <b-col lg="4">
                    <b-form-group id="group-bank-commission" label="Банковская коммисия для ИП">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.bank_commission"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="canLocationReadFinance() && newItem.payment_type === 2">
                  <b-col lg="4">
                    <b-form-group id="group-ip-commission" label="Комиссия на вывод ИП">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.ip_commission"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-tab>

            <b-tab>
              <template #title>
                <v-icon name="buttons/page_list" :size="13" class="mr-2"/>
                <span>Детали</span>
              </template>
              <b-card class="custom-card">
                <b-form-group id="group-address" :label="$t('message.locations.modal.addressInput')">
                  <b-form-input
                    type="text"
                    :disabled="isDisabled"
                    v-model="newItem.address"
                  />
                </b-form-group>

                <b-row>
                  <b-col cols="4">
                    <b-form-group id="group-contract" :label="$t('message.locations.modal.contractInput')">
                      <b-form-input
                        type="text"
                        :disabled="isDisabled"
                        v-model="newItem.contract"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="group-contact" :label="$t('message.locations.modal.contactInput')">
                      <b-form-input
                        type="text"
                        :disabled="isDisabled"
                        v-model="newItem.contact"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-form-group id="group-description" label="Описание">
                  <b-form-textarea
                    :disabled="isDisabled"
                    placeholder="Заполните необходимую информацию об объекте"
                    v-model.lazy="newItem.description"
                    :rows="5"
                    :max-rows="20"
                    no-resize
                    class="text-small"
                  />
                </b-form-group>
                <b-form-group style="overflow-anchor: none;" id="group-posting-order" label="Порядок выхода">
                  <b-form-textarea
                    :disabled="isDisabled"
                    placeholder="Заполните необходимую информацию о порядке выхода на объект"
                    v-model="newItem.posting_order"
                    :rows="5"
                    :max-rows="20"
                    no-resize
                    class="text-small"
                  />
                </b-form-group>
                <b-form-group style="overflow-anchor: none;" id="group-interview-script" label="Скрипт интервью">
                  <b-form-textarea
                    :disabled="isDisabled"
                    placeholder="Критически важные вопросы для кандидатов перед их одобрением"
                    v-model="newItem.interview_script"
                    :rows="5"
                    :max-rows="20"
                    class="text-small"
                    no-resize
                  />
                </b-form-group>
                <b-form-group style="overflow-anchor: none;" id="group-employment-documents" label="Документы для трудоустройства">
                  <b-form-textarea
                    :disabled="isDisabled"
                    placeholder="Введите требуемые документы для трудоустройства граждан СНГ и ЕАЭС"
                    v-model="newItem.employment_documents"
                    :rows="5"
                    :max-rows="20"
                    no-resize
                    class="text-small"
                  />
                </b-form-group>
              </b-card>
            </b-tab>

            <b-tab>
              <template #title>
                <v-icon name="buttons/user_group_add" :size="13" class="mr-2"/>
                <span>Вакансии</span>
              </template>
              <location-vacancies ref="location_vacancies" :is-disabled="isDisabled"/>
            </b-tab>

            <b-tab>
              <template #title>
                <v-icon name="navbar/recruit_tasks" :size="13" class="mr-2"/>
                <span>Подбор</span>
              </template>
              <recruit-tasks
                v-if="newItem.id"
                :location-id="newItem.id"
                :location-name="newItem.name"
                :disabled-routing="true"
                :is-integrated="true"
                @refresh="onRecruitTasksRefresh"
              />
              <b-alert v-else show variant="danger" class="pb-3 mb-0">
                Сохраните карточку объекта, чтобы просматривать заявки на подбор.
              </b-alert>
            </b-tab>

            <b-tab :active.sync="servicesTabActive">
              <template #title>
                <v-icon name="buttons/card_container" :size="13" class="mr-2"/>
                <span>Услуги исполнителей</span>
              </template>
              <location-work-services ref="location_work_services" :is-disabled="isDisabled"/>
            </b-tab>

            <b-tab>
              <template #title>
                <v-icon name="buttons/work" :size="13" class="mr-2"/>
                <span>Работы</span>
              </template>
              <location-works ref="location_works" :is-disabled="isDisabled"/>
            </b-tab>

            <b-tab v-if="canLocationReadFinance()">
              <template #title>
                <v-icon name="buttons/payment" :size="13" class="mr-2"/>
                <span>Расходы</span>
              </template>
              <location-costs ref="location_costs" :is-disabled="isDisabled"/>
            </b-tab>

            <b-tab v-if="canLocationReadFinance()">
              <template #title>
                <v-icon name="navbar/staffs" :size="13" class="mr-2"/>
                <span>Сотрудники</span>
              </template>

              <b-row v-if="canLocationReadFinance()">
                <b-col cols="4">
                  <b-form-group id="group_rate" label="Тип ставки для сотрудников" class="mb-4">
                    <b-form-radio-group
                      size="sm"
                      v-model="newItem.rate_type"
                      :disabled="isDisabled || !canLocationEditFinance()"
                      :options="rateOptions"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-card class="custom-card mb-2">
                <h6 class="text-muted text-small">РУКОВОДИТЕЛЬ</h6>
                <div class="d-flex align-items-center">
                  <user-select
                    ref="project_select"
                    :is-disabled="isDisabled || !canLocationEditFinance()"
                    @onSelect="onSelectProject"
                  />
                  <b-button class="custom-btn-primary ml-2" :disabled="isDisabled || !selectedProjectId || !canLocationEditFinance()" @click="onAddProject(selectedProjectId)">
                    Добавить
                  </b-button>
                </div>

                <b-table
                  id="location-projects"
                  ref="projects"
                  class="mb-0 text-small"
                  thead-class="d-none"
                  :busy.sync="isBusy"
                  :items="projects"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                >
                  <template #table-busy>
                    <div class="text-center text-success my-2">
                      <b-spinner class="align-middle"/>
                      <strong>Загрузка</strong>
                    </div>
                  </template>

                  <template #cell(name)="row">
                    {{row.item.name}}
                    <p class="text-secondary m-0">
                      {{row.item.role_name}}
                    </p>
                  </template>

                  <template #cell(rate)="row">
                    <b-input-group size="sm" prepend="Ставка">
                      <b-form-input
                        id="input-rate"
                        type="text"
                        inputmode="decimal"
                        :disabled="isDisabled || !canLocationEditFinance()"
                        size="sm"
                        autocomplete="off"
                        v-model="row.item.rate"
                      />

                      <template #append>
                        <b-input-group-text size="sm">{{ getRateSymbol() }}</b-input-group-text>
                      </template>
                    </b-input-group>
                  </template>

                  <template #cell(action)="row">
                    <b-button variant="link" :disabled="isDisabled || !canLocationEditFinance()" @click="onRemoveProject(row.item)">
                      <v-icon name="buttons/trash" :size="16"/>
                    </b-button>
                  </template>
                </b-table>
              </b-card>

              <b-card class="custom-card">
                <h6 class="text-muted text-small">СОТРУДНИКИ</h6>
                <div class="d-flex align-items-center">
                  <user-select
                    ref="user_select"
                    :is-disabled="isDisabled || !canLocationEditFinance()"
                    @onSelect="onSelectUser"
                  />
                  <b-button class="custom-btn-primary ml-2" :disabled="isDisabled || !selectedUserId || !canLocationEditFinance()" @click="onAddUser(selectedUserId)">
                    Добавить
                  </b-button>
                </div>

                <b-table
                  id="location-users"
                  ref="users"
                  class="mb-0 text-small"
                  thead-class="d-none"
                  :busy.sync="isBusy"
                  :items="users"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                >
                  <template #table-busy>
                    <div class="text-center text-success my-2">
                      <b-spinner class="align-middle"/>
                      <strong>Загрузка</strong>
                    </div>
                  </template>

                  <template #cell(name)="row">
                    {{row.item.name}}
                    <p class="text-secondary m-0">
                      {{row.item.role_name}}
                    </p>
                  </template>

                  <template #cell(rate)="row">
                    <b-input-group size="sm" prepend="Ставка">
                      <b-form-input
                        id="input-rate"
                        type="text"
                        inputmode="decimal"
                        :disabled="isDisabled || !canLocationEditFinance()"
                        size="sm"
                        autocomplete="off"
                        v-model="row.item.rate"
                      />

                      <template #append>
                        <b-input-group-text size="sm">{{ getRateSymbol() }}</b-input-group-text>
                      </template>
                    </b-input-group>
                  </template>

                  <template #cell(action)="row">
                    <b-button variant="link" :disabled="isDisabled || !canLocationEditFinance()" @click="onRemoveUser(row.item)">
                      <v-icon name="buttons/trash" :size="16"/>
                    </b-button>
                  </template>
                </b-table>
              </b-card>

            </b-tab>

            <b-tab>
              <template #title>
                <v-icon name="buttons/phone" :size="13" class="mr-2"/>
                <span>Контакты</span>
              </template>
              <location-contacts ref="location_contacts" :is-disabled="isDisabled"/>
            </b-tab>

            <b-tab>
              <template #title>
                <v-icon name="navbar/reports" :size="13" class="mr-2"/>
                <span>Документы</span>
              </template>
              <location-files ref="location_files" :is-disabled="isDisabled"/>
            </b-tab>

            <b-tab>
              <template #title>
                <v-icon name="buttons/file" :size="13" class="mr-2"/>
                <span>Медиафайлы</span>
              </template>
              <location-media ref="location_media_files" :is-disabled="isDisabled" :location-id="newItem.id"/>
            </b-tab>
          </b-tabs>
        </template>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import locations from "../../network/locations";
import users from "../../network/users";
import catalogs from "../../network/catalogs";
import customers from "../../network/customers";
  import helpers from "../../utilites/helpers";
  import permissions, {PERM} from "../../utilites/permissions";
  import BaseSelect from "../../utilites/commonUi/BaseSelect.vue";
    import CustomerSelect from "../Customers/CustomerSelect";
    import UserSelect from "../Users/UserSelect";
    import LocationCosts from "./LocationCosts";
    import LocationFiles from "./LocationFiles";
    import LocationContacts from "./LocationContacts";
    import LocationWorks from "./LocationWorks";
    import LocationWorkServices from "./LocationWorkServices";
    import OrganizationSelect from "../Organizations/OrganizationSelect";
    import LocationVacancies from "./LocationVacancies.vue";
    import LocationMedia from "./LocationMedia.vue";
    import RecruitTasks from "../Recruiting/RecruitTasks.vue";
    import TownSelect from "../Catalogs/Towns/TownSelect.vue";
    import LocationStatusSelect from "../Catalogs/LocationStatuses/LocationStatusSelect.vue";
    import MarketingSourceSelect from "../Catalogs/MarketingSources/MarketingSourceSelect.vue";

export default {
  name: "Location",
  components: { MarketingSourceSelect, LocationStatusSelect, TownSelect, BaseSelect, LocationMedia, LocationVacancies, LocationContacts, CustomerSelect, UserSelect, LocationCosts, LocationFiles, OrganizationSelect, LocationWorks, LocationWorkServices, RecruitTasks
  },
  mixins: [
    locations, catalogs, users, customers,
    helpers, permissions
  ],
  props: ['isRead'],
  data() {
    return {
      title:'Объект',
      newItem: {
        id: null,
        name: '',
        description: '',
        posting_order: '',
        interview_script: '',
        employment_documents: '',
        address: '',
        contact: '',
        organization_id: 0,
        organization_name: '',
        customer_id: 0,
        customer_name: '',
        contract: '',
        town_id: null,
        town_name: '',
        marketing_source_id: null,
        marketing_source_comment: '',
        location_users: [],
        payment_type: 1,
        price: 0,
        rate: 0,
        read_only: false,
        rate_type: 1,
        management_cost: 5,
        smz_cost: 2,
        profit_tax: 2,
        nds: 22,
        transfer_commission: 30,
        bank_commission: 1,
        ip_commission: 7,
        category_name: '',
        status_id: null,
      },
      customer: {},
      isDisabled: false,
      paymentOptions: [
        { value: 0, text: 'Нал' },
        { value: 1, text: 'ООО' },
        { value: 2, text: 'ИП' },
      ],
      rateOptions: [
        { value: 1, text: 'Проценты от прибыли по заявке (%)' },
        { value: 2, text: 'Рубли за единицу работы в заявке (₽)' },
      ],
      users: [],
      projects: [],
      selectedUserId: null,
      selectedProjectId: null,
      fields: [
        {
          key: 'name',
          label: 'Имя',
          class: 'location-user-name'
        },
        {
          key: 'rate',
          label: 'Ставка',
          class: '',
        },
        {
          key: 'action',
          label: 'Действия',
          class: 'text-center',
        },
      ],
      currentPage: 1,
      perPage: 40,
      isBusy: false,
      loading: false,
      readOnlyButtonVisible: false,
      servicesTabActive: false,
      isCustomerOpen: false,
    }
  },
  async created() {
    this.isBusy = true;
    this.loading = true;

    await this.updateView();
  },
  watch: {
    servicesTabActive(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          if (this.$refs.location_work_services) {
            this.$refs.location_work_services.showHint();
          }
        });
      }
    }
  },
  methods: {
    async updateView() {
      const locationId = this.$route.params.location_id;
      if (locationId != null) {
        await this.getLocation(locationId);
      } else {
        this.isBusy = false;
        this.loading = false;
      }
    },
    async getLocation(locationId) {
      const locationResult = await this.getLocationById(locationId);
      this.isBusy = false;

      if (!locationResult || !locationResult.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = locationResult.data;
      this.title = this.newItem.name;

      this.prepareReadOnly();

      await this.getCustomer(this.newItem.customer_id);
      await this.$refs.customer_select.configure(this.newItem.customer_id);

      if (this.$refs.organization_select != null) {
        await this.$refs.organization_select.configure(this.newItem.organization_id);
      }

      const location_users = this.newItem.location_users;

      let locationUsers = [];
      let locationProjects = [];
      for (const index in location_users) {
        const location_user = location_users[index];
        const user = await this.loadUser(location_user.user_id);
        const locationUser = this.mapUserToLocationUser(user, location_user.rate);
        if (location_user.location_position_id === 2) {
          locationUsers.push(locationUser);
        }

        if (location_user.location_position_id === 1) {
          locationProjects.push(locationUser);
        }
      }

      this.users = locationUsers;
      this.projects = locationProjects;

      if (this.$refs.project_select != null) {
        await this.$refs.project_select.configure(0);
      }

      if (this.$refs.user_select != null) {
        await this.$refs.user_select.configure(0);
      }

      if (this.$refs.location_costs != null) {
        await this.$refs.location_costs.configure(this.newItem.id);
      }

      if (this.$refs.location_contacts != null) {
        await this.$refs.location_contacts.configure(this.newItem.id);
      }

      if (this.$refs.location_works != null) {
        await this.$refs.location_works.configure(this.newItem.id, this.newItem.locations_work_types);
      }

      if (this.$refs.location_work_services != null) {
        await this.$refs.location_work_services.configure(this.newItem.id, this.newItem.location_work_services);
      }

      // Конфигурируем файлы
      if (this.$refs.location_files != null) {
        await this.$refs.location_files.configure(this.newItem.id);
      }

      if (this.$refs.location_vacancies != null) {
        await this.$refs.location_vacancies.configure(this.newItem.id, this.newItem.name);
      }

      this.loading = false;
    },
    onBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/locations').catch(()=>{});
      }
    },
    async handleSubmit() {
      if (this.newItem.name.length < 3) {
        this.showSubmitError("Введите название объекта (минимум 3 символа).");
        return;
      }

      if (this.newItem.customer_id === 0) {
        this.showSubmitError("Выберите заказчика объекта.");
        return;
      }

      if (!this.newItem.town_id) {
        this.showSubmitError("Выберите город.");
        return;
      }

      if (this.newItem.organization_id === 0) {
        this.showSubmitError("Выберите организацию объекта.");
        return;
      }

      if (this.newItem.marketing_source_id === 0) {
        this.showSubmitError("Выберите источник объекта.");
        return;
      }

      if (this.users.length === 0) {
        this.showSubmitError("Добавьте сотрудников имеющих доступ к объекту.");
        return;
      }

      if (!this.users.concat(this.projects).every(user => Number.isFinite(this.parseRate(user.rate)))) {
        this.showSubmitError("Укажите ставку сотрудника или руководителя числом, например 1,5.");
        return;
      }

      if (this.$refs.location_works) {
        if (!this.$refs.location_works.items.every(v => v.work_type_id > 0)) {
          this.showSubmitError('Выберите вид работ объекта.');
          return;
        }
      }

      if (this.$refs.location_work_services) {
        if (!this.$refs.location_work_services.items.every(v => v.work_service_id > 0)) {
          this.showSubmitError('Выберите вид услуги исполнителя.');
          return;
        }
      }

      if (this.$refs.location_vacancies) {
        if (!this.$refs.location_vacancies.items.every(v => v.vacancy_id > 0)) {
          this.showSubmitError('Выберите вакансию объекта.');
          return;
        }

        if (!this.$refs.location_vacancies.items.every(v => v.workers_count > 0)) {
          this.showSubmitError('Укажите требуемое количество исполнителей.');
          return;
        }
      }

      if (this.$refs.location_costs) {
        if (!this.$refs.location_costs.items.every(v => v.cost_type > 0)) {
          this.showSubmitError('Введите тип расходов объекта.');
          return;
        }

        if (!this.$refs.location_costs.items.every(v => this.dateValidation(v.start_date))) {
          this.showSubmitError('Введите дату расходов объекта.');
          return;
        }

        if (!this.$refs.location_costs.items.every(v => this.dateValidation(v.end_date))) {
          this.showSubmitError('Введите дату расходов объекта.');
          return;
        }

        if (!this.$refs.location_costs.items.every(v => this.isNumberOrNull(v.sum))) {
          this.showSubmitError("Укажите сумму расходов в виде числа.");
          return;
        }
      }

      if (this.$refs.location_contacts && !this.$refs.location_contacts.validateContacts()) {
        return;
      }

      this.loading = true;

      // Менеджеры
      this.newItem.location_users = this.users.map(function (obj) {
        return {
          location_id: this.newItem.id,
          user_id: obj.id,
          rate: this.parseRate(obj.rate),
          location_position_id: 2,
          location_position_name: 'Менеджер',
        }
      }.bind(this));

      // Руководители
      const location_projects = this.projects.map(function (obj) {
        return {
          location_id: this.newItem.id,
          user_id: obj.id,
          rate: this.parseRate(obj.rate),
          location_position_id: 1,
          location_position_name: 'Руководитель',
        }
      }.bind(this));

      // Объединяем пользователей
      this.newItem.location_users = this.newItem.location_users.concat(location_projects);

      if (this.$refs.location_works != null) {
        this.newItem.locations_work_types = this.$refs.location_works.items;
      }

      if (this.$refs.location_work_services != null) {
        this.newItem.location_work_services = this.$refs.location_work_services.items;
      }

      let locationResult;
      if (this.newItem.id > 0) {
        locationResult = await this.putLocation(this.newItem);
      } else {
        locationResult = await this.postLocation(this.newItem);
      }

      if (!locationResult || !locationResult.data) {
        this.showError('Что-то пошло не так. Попробуйте обновить страницу и повторить действие.');
        this.loading = false;
        return;
      }

      this.newItem.id = locationResult.data.id;

      // После сохранения location_id сохраняем остальные сущности
      if (this.$refs.location_vacancies != null) {
        const vacancyResult = await this.$refs.location_vacancies.saveVacancies(this.newItem);

        if (vacancyResult && vacancyResult.error) {
          this.showSubmitError("Ошибка сохранения вакансий объекта.");
          this.loading = false;
          return;
        }
      }

      if (this.$refs.location_costs) {
        const costsResult = await this.$refs.location_costs.saveCosts(this.newItem.id);

        if (costsResult.error != null) {
          this.showSubmitError("Ошибка сохранения расходов.");
          this.loading = false;
          return;
        }
      }

      if (this.$refs.location_contacts) {
        const contactsResult = await this.$refs.location_contacts.saveContacts(this.newItem.id);

        if (contactsResult.error != null) {
          this.showSubmitError("Ошибка сохранения контактов.");
          this.loading = false;
          return;
        }
      }

      this.loading = false;
      this.$emit('refresh');
      this.onBack();
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    onRecruitTasksRefresh() {
      if (this.$refs.location_contacts && this.newItem.id) {
        this.$refs.location_contacts.configure(this.newItem.id);
      }
    },
    async onSelectCustomer(customerId, customer) {
      this.newItem.customer_id = customerId;
      this.newItem.customer_name = customer ? customer.name : '';
      await this.getCustomer(customerId);
    },
    async onSelectOrg(orgId) {
      this.newItem.organization_id = orgId;
      if (this.$refs.organization_select != null) {
        this.newItem.organization_name = this.$refs.organization_select.item.name;
      }
    },
    onSelectUser(userId) {
      this.selectedUserId = userId;
    },
    onSelectProject(userId) {
      this.selectedProjectId = userId;
    },
    async loadUser(userId) {
      const resultUser = await this.getUserById(userId);

      if (resultUser.data == null) return null;

      return resultUser.data;
    },
    onSelectTown(town) {
      if (town) {
        this.$set(this.newItem, 'town_id', town.id);
        this.$set(this.newItem, 'town_name', town.name);
      } else {
        this.$set(this.newItem, 'town_id', null);
        this.$set(this.newItem, 'town_name', '');
      }
    },
    onSelectLocationStatus(status) {
      if (status) {
        this.$set(this.newItem, 'status_id', status.id);
      } else {
        this.$set(this.newItem, 'status_id', null);
      }
    },
    onSelectMarketingSource(source) {
      if (source) {
        this.$set(this.newItem, 'marketing_source_id', source.id);
      } else {
        this.$set(this.newItem, 'marketing_source_id', null);
      }
    },
    async onAddUser(userId) {
      if (userId == null) return;

      if (this.isUserExist(userId)) {
        this.showSubmitError("Сотрудник уже добавлен.")
        return;
      }

      const user = await this.loadUser(userId);

      const locationUser = this.mapUserToLocationUser(user, 0);
      this.users.push(locationUser);

      this.$refs.user_select.onClear();
    },
    onRemoveUser(user) {
        this.setModalDelete(user, this.users, 'Удаление менеджеров');
    },
    async onAddProject(userId) {
      if (userId == null) return;

      if (this.isProjectExist(userId)) {
        const message = "Сотрудник уже добавлен";
        this.showError(message);
        return;
      }

      const user = await this.loadUser(userId);
      const locationUser = this.mapUserToLocationUser(user, 0);

      if (this.projects.length > 0) {
        this.projects.splice(0, 1, locationUser);
      } else {
        this.projects.push(locationUser);
      }

      this.$refs.project_select.onClear();
      this.selectedProjectId = null;
    },
    onRemoveProject(user) {
        this.setModalDelete(user, this.projects, 'Удаление руководителей');
    },
    setModalDelete(item, array, title) {
      const index = array.indexOf(item);
      if (index !== -1) {
        this.deleteRow = item;
      }
      const message = `Вы уверены, что хотите удалить сотрудника ${this.deleteRow.name}?`;
      this.showModalDelete(title, message, function () {
        array.splice(index, 1);
      }.bind(this));
    },
    isUserExist(id) {
      return this.users.find(x => x.id === id) !== undefined;
    },
    isProjectExist(id) {
      return this.projects.find(x => x.id === id) !== undefined;
    },
    parseRate(rate) {
      const value = String(rate).trim().replace(',', '.');
      return value === '' ? NaN : Number(value);
    },
    mapUserToLocationUser(user, rate) {
      return {
        id: user.id,
        name: user.name,
        role: user.role,
        role_name: user.role_name,
        rate: rate
      }
    },
    canLocationReadFinance() {
      if (this.hasPermission([PERM.LOCATION_READ_FINANCE])) {
        return true;
      }
      return false;
    },
    canLocationEditFinance() {
      if (this.hasPermission([PERM.LOCATION_EDIT_FINANCE])) {
        return true;
      }
      return false;
    },
    readOnlyTapped() {
      this.newItem.read_only = !this.newItem.read_only;
    },
    getReadOnlyVariant() {
      return this.newItem.read_only ? 'danger' : 'success';
    },
    getReadOnlyTitle() {
      return this.newItem.read_only ? 'Редактирование запрещено' : 'Редактирование разрешено';
    },
    getReadOnlyIcon() {
      if (this.newItem.read_only) {
        return "lock";
      } else {
        return "edit";
      }
    },
    prepareReadOnly() {
      if (this.$route.name === 'LocationView') {
        this.isDisabled = true;
        this.readOnlyButtonVisible = false;
        return;
      }

      if (this.hasPermission([PERM.LOCATION_EDIT_OTHER])) {
        this.readOnlyButtonVisible = true;
        this.isDisabled = false;
        return
      }

      if (this.hasPermission([PERM.LOCATION_EDIT])) {
        if (this.newItem.read_only) {
          this.isDisabled = true;
        }
      }
    },
    getRateSymbol() {
      switch (this.newItem.rate_type) {
        case 1: return "%";
        case 2: return "₽";
        default: return "";
      }
    },
    async getCustomer(customerId) {
      if (customerId === 0) return;

      const result = await this.getCustomerById(customerId);

      if (result && result.data) {
        this.customer = result.data;
        this.updateMarketingSource(result.data);
      }
    },
    updateMarketingSource(result) {
      if (this.newItem.marketing_source_id === 0) {
        this.newItem.marketing_source_id = result.marketing_source_id;
      }
    }
  }
}
</script>

<style>
.location-user-name {
  width: 300px;
}

.header-top {
  z-index: 1030 !important;
}

#location-users td {
  vertical-align: middle;
  padding: 10px;
}

/* Chrome, Safari, Edge, Opera */
#input-rate::-webkit-outer-spin-button,
#input-rate::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
#input-rate[type=number] {
  -moz-appearance: textfield;
}

#location-ellipsis-loading {
  white-space: nowrap;
  display: inline-block;
}

@keyframes blink {
  0% { content: "."; }
  33% { content: ".."; }
  66% { content: "..."; }
  100% { content: "."; }
}

#location-ellipsis-loading::after {
  content: ".";
  animation: blink 1.5s infinite step-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/Location.vue